import { render } from "./VizioOne.vue?vue&type=template&id=5fbbcfe5"
import script from "./VizioOne.vue?vue&type=script&lang=js"
export * from "./VizioOne.vue?vue&type=script&lang=js"

import "./VizioOne.vue?vue&type=style&index=0&id=5fbbcfe5&lang=css"
script.render = render

export default script